import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import { buttonSX } from '@/components/blocks/DpLibrary/DpButtonForm/style/main';
import { combineSX } from '@/utils/combineSX';
import { Stack, SxProps } from '@mui/material';

export const DpButtonForm = ({
	label,
	sx,
	onClick,
}: {
	label: string;
	sx?: SxProps;
	onClick?: () => void;
}) => (
	<Stack alignItems="center">
		<DpButton
			type="submit"
			sx={combineSX([buttonSX, ...(Array.isArray(sx) ? sx : [sx])])}
			onClick={onClick}
		>
			{label}
		</DpButton>
	</Stack>
);
